/* eslint-disable no-unused-vars */
import React, { memo } from 'react'
import { ContactsPageConfig } from '../configuration'
import SmoothScroll from 'smooth-scroll'
import { Logo, Menu } from '../icons'
import Button from './../Button'
import { useAppDispatch } from '../app/hooks/reduxHooks'
import { setDialogOpen } from '../app/pageIndexSlice'
import styles from './Navbar.module.sass'

function Navbar() {
    const anchorScroll = new SmoothScroll('a[href*="#"]', {
        speedAsDuration: true,
        speed: 1000
    })
    const dispatch = useAppDispatch()
    const handleClick = () => {
        dispatch(setDialogOpen(true))
    }
    return (
        <div className={styles.root}>
            <a href='#inizio' className={styles.a} >
                <Logo className={styles.logo} />
            </a>
            <span className={styles.span} >
                <Button href={ContactsPageConfig.slug} label={ContactsPageConfig.label} size="sm" className={styles.button} responsive />
                <button className={styles.menu} onClick={handleClick}>
                    <Menu />
                </button>
            </span>
        </div>
    )
}

export default memo(Navbar)
